import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';

/** Removes the leading `#` from the hash */
function parseHash(hash: string): string | null {
  return hash.length === 0 ? null : hash.substring(1);
}

/** Parses the URL hash from `window.location.hash` */
export default function useHash() {
  const $ = _c(5);
  const searchParams = useSearchParams();
  const [hash, setHash] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setHash(parseHash(window.location.hash));
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== searchParams) {
    t1 = [searchParams];
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = hash as T | null;
  let t3;
  if ($[3] !== t2) {
    t3 = [t2, setHash];
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3 as const;
}
function _temp() {
  return typeof window !== "undefined" ? parseHash(window.location.hash) : null;
}